import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import './OpeningSection.css';

const hours = [
  { day: 'Monday', time: '12:00 pm – 12:00 am' },
  { day: 'Tuesday', time: '12:00 pm – 12:00 am' },
  { day: 'Wednesday', time: '12:00 pm – 12:00 am' },
  { day: 'Thursday', time: '12:00 pm – 12:00 am' },
  { day: 'Friday', time: '12:00 pm – 01:00 am' },
  { day: 'Saturday', time: '12:00 pm – 01:00 am' },
  { day: 'Sunday', time: '12:00 pm – 12:00 am' },
];

const OpeningSection = () => (
  <section className="opening-section container-fluid py-5">
    <div className="row align-items-center">
      {/* Text Column */}
      <div className="col-lg-6 col-md-12  text-center mb-4 mb-lg-0">
        <h2 className="opening-title">
          <span className="highlight">Euless</span><br />
          Opening Hours
        </h2>
        <div className="opening-table mx-auto">
          {hours.map(h => (
            <div className="opening-row d-flex justify-content-between" key={h.day}>
              <span className="opening-day">{h.day}</span>
              <span className="opening-time">{h.time}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Image Column */}
      <div className="col-lg-6 col-md-12  text-center">
        <img
          src={process.env.PUBLIC_URL + '/assets/openinggrid.png'}
          alt="Opening"
          className="opening-img-single img-fluid"
        />
      </div>
    </div>
  </section>
);

export default OpeningSection;
